import { Badge } from "../../../../../core/Badge.js";
import { Text } from "../../../../../core/Text.js";
import type { BattleRoomStageContent } from "../../../battlesContent.js";

/**
 * The round being opened, named over the battle's reels (the app's own, one lane per seat, from
 * the countdown through the last round). A replay is marked as one.
 */
export function BattleRoomStage({ roundLabel, replayLabel, reels }: BattleRoomStageContent) {
  return (
    <section aria-label={roundLabel} className="flex min-w-0 flex-col gap-3">
      <div className="flex items-center justify-between gap-3">
        <Text as="h2" variant="heading-h2" tone="primary" aria-live="polite">
          {roundLabel}
        </Text>
        {replayLabel && <Badge tone="accent">{replayLabel}</Badge>}
      </div>
      <div className="min-w-0">{reels}</div>
    </section>
  );
}
